import BoxIcon from "$/lib/icons/tabs/BoxIcon";
import FirelightIcon from "$/lib/icons/tabs/FirelightIcon";
import LightningIcon from "$/lib/icons/tabs/LightningIcon";
import type { ComponentProps } from "react";

export type TTab = {
  id: string;
  label: string;
  Icon: (props: ComponentProps<"svg">) => JSX.Element;
};

export const DEFAULT_MARKET_MONITORING_TABS = [
  {
    id: "ELECTRICITY",
    label: "Electricité",
    Icon: LightningIcon,
  },
  {
    id: "GAS",
    label: "Gaz naturel",
    Icon: FirelightIcon,
  },
  {
    id: "OTHER_MARKETS",
    label: "Autres marchés",
    Icon: BoxIcon,
  },
  {
    id: "ELECTRICITY_ANALYSIS",
    label: "Analyse électricité",
    Icon: LightningIcon,
  },
  {
    id: "GAS_ANALYSIS",
    label: "Analyse gaz naturel",
    Icon: FirelightIcon,
  },
  {
    id: "FUNDAMENTALS",
    label: "Fondamentaux",
    Icon: BoxIcon,
  },
];

export const DEFAULT_GRAPH_TABS = [
  {
    id: "CURRENT_MONTH",
    label: "Mois en cours",
  },
  {
    id: "LAST_MONTH",
    label: "Mois dernier",
  },
  {
    id: "LAST_3_MONTHS",
    label: "3 derniers mois",
  },
  {
    id: "LAST_6_MONTHS",
    label: "6 derniers mois",
  },
  {
    id: "CURRENT_YEAR",
    label: "Année en cours",
  },
];

export const DEFAULT_TABLE_PERIOD_TABS = [
  { id: "YEAR", label: "Année" },
  { id: "QUARTER", label: "Trimestre" },
  { id: "MONTH", label: "Mois" },
  { id: "DAY", label: "Jour" },
];

export const ENERGY_KPIS = {
  BIOMASS: { label: "Biomasse", color: "#2c8240" },
  WASTE: { label: "Déchets industriels", color: "#acacac" },
  FOSSIL_GAS: { label: "Gaz issu du charbon", color: "#a8a188" },
  FOSSIL_OIL: { label: "Fioul", color: "#564745" },
  FOSSIL_HARD_COAL: { label: "Charbon", color: "#545454" },
  HYDRO_PUMPED_STORAGE: { label: "Hydro - step", color: "#4d24de" },
  HYDRO_RUN_OF_RIVER_AND_POUNDAGE: {
    label: "Hydro - au fil de l'eau",
    color: "#2a7de199",
  },
  HYDRO_WATER_RESERVOIR: { label: "Hydro - lacs", color: "#a1cfff90" },
  WIND_ONSHORE: { label: "Eolien terrestre", color: "#57b7e3" },
  WIND_OFFSHORE: { label: "Eolien offshore", color: "#83d6f9" },
  SOLAR: { label: "Solaire", color: "#f5c800" },
  NUCLEAR: { label: "Nucléaire ", color: "#9e6bfa " },
};
